var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column",style:({ 'min-height': _vm.calc })},[_c('v-row',{staticClass:"align-self-center",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }